import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";

const IconSetting = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        fontSize: "inherit",
        ...sx,
        width: "24px !important",
        height: "24px !important",
      }}
      {...otherProps}
    >
      <g clipPath="url(#clip0_295_1593)">
        <path
          d="M23.6235 14.5434V10.7129L21.2331 10.2366C21.0305 9.49684 20.6558 8.98003 20.281 8.32134L21.7193 6.4061L18.8528 3.53829L16.9385 4.97726C16.2699 4.59219 15.7534 4.21724 15.014 4.01457L14.5379 1.62305H10.7092L10.2331 4.01457C9.4937 4.21724 8.97713 4.59219 8.31875 4.97726L6.40438 3.53829L3.5379 6.4061L4.97621 8.32134C4.62169 8.99016 4.22667 9.52724 4.01396 10.2366L1.62354 10.7129V14.5434L4.01396 15.0196C4.25705 15.7695 4.59131 16.2762 4.96608 16.9349L3.52777 18.8501L6.39425 21.7179L8.30862 20.279C8.95687 20.7147 9.47344 21.0289 10.223 21.2315L10.699 23.623H14.5278L15.0038 21.2315C15.7432 21.0289 16.2598 20.6539 16.9182 20.279L18.8326 21.7179L21.699 18.8501L20.2607 16.9349C20.6456 16.2762 21.0103 15.7695 21.2129 15.0196L23.6235 14.5434Z"
          stroke="currentColor"
          fill="transparent"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6235 16.8237C14.9395 16.8237 16.8169 14.9454 16.8169 12.6284C16.8169 10.3114 14.9395 8.43311 12.6235 8.43311C10.3076 8.43311 8.43018 10.3114 8.43018 12.6284C8.43018 14.9454 10.3076 16.8237 12.6235 16.8237Z"
          stroke="currentColor"
          fill="transparent"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_295_1593">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.14502)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default memo(IconSetting);
